'use client';

import Image from 'next/image';
import type React from 'react';
import { forwardRef } from 'react';
import CheckedIcon from '@/assets/svg/ic_checked-box.svg';
import UncheckedIcon from '@/assets/svg/ic_unchecked-box.svg';
import styles from './CheckboxInput.module.css';

export interface OutlinedInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string | React.ReactElement;
  'data-testid'?: string;
}

export const CheckboxInput = forwardRef<HTMLInputElement, OutlinedInputProps>(
  ({ label, checked = false, onChange, className = '', ...props }, ref) => {
    const iconTestId =
      typeof props['data-testid'] === 'string'
        ? `${props['data-testid']}-icon`
        : undefined;

    return (
      <label
        className={`${styles.checkboxInput} ${
          checked ? styles.checked : ''
        } ${className}`}
      >
        <span className={styles.icon} data-testid={iconTestId}>
          <input
            {...props}
            checked={checked}
            type="checkbox"
            ref={ref}
            onChange={onChange}
            hidden
          />
          {checked ? (
            <Image
              src={CheckedIcon}
              aria-hidden="true"
              width={20}
              height={20}
              alt=""
              unoptimized
            />
          ) : (
            <Image
              src={UncheckedIcon}
              aria-hidden="true"
              width={20}
              height={20}
              alt=""
              unoptimized
            />
          )}
        </span>
        <span className={styles.label}>{label}</span>
      </label>
    );
  },
);

CheckboxInput.displayName = 'CheckboxInput';

export default CheckboxInput;
